import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/square.constants';

export * from './customer/default/square.constants';

export const templates = {
  Square: 'Square',
};

const RATIO = 1;

const { sizes, imageOptions } = getElementSize(ITEMS_BY_BREAKPOINTS, RATIO, templates.Square);
export { sizes, imageOptions };
